import { useCallback, useEffect, useReducer, useState } from "react";
import MatchTitle from "../items/MatchTitle";
import CustomText from "../CustomText";
import Currency from "../../config/Currency";
import MatchMyPickButtonContainer from "../cards/MatchMyPickButtonContainer";
import MatchHeaderDropdown, { MatchType } from "../MatchHeaderDropdown";
import Colors from "../../config/Colors";
import HeaderDropdown from "../HeaderDropdown";
import { LeaderBoardResponse, MyRanking, RankedUser } from "../../services";
import Point from "../../assets/PointsIcon.svg";
import Rank from "../../assets/RankIcon.svg";
import Step from "../../assets/StepIcon.svg";
import { percentageCalculator } from "./MyPickSegment";
import { Oval } from "react-loader-spinner";

import {
  cleanLeaderBoard,
  getCount,
  getLeaderBoard,
  getRank,
  getTotalPoint,
  getUserData,
} from "../../config/UserStorer";
import ReactPaginate from "react-paginate";
import Header from "../Header";
import { formatNumber } from "../../pages/MainPage";

interface MatchProps {
  amount?: string;
  setActive: (active: number) => void;
  tabActive?: number;
  match?: MatchType;
  data?: RankedUser[];
  name?: string;
  totalTime?: number;
  myData?: MyRanking;
  onReload: () => void;
  goHome: () => void;
  page: number;
  setPage: (page: number) => void;
  onShare: () => void;
  onLogoClick?: () => void;
  onLoad: (active: number) => Promise<LeaderBoardResponse>;
}

export const TabContainer = ({
  active,
  onClick,
}: {
  active: number;
  onClick: (active: number) => void;
}) => {
  return (
    <div
      style={{
        display: "flex",
        width: "95%",
        borderRadius: 50,
        padding: 2,
        margin: 5,
      }}
    >
      <div
        className={`tab ${active === 1 && "tab-active"}`}
        onClick={() => onClick(1)}
      >
        <CustomText
          size={"medium"}
          color={active === 1 ? "black" : "white"}
          weight={"700"}
        >
          Series
        </CustomText>
      </div>
      <div
        className={`tab ${active === 2 && "tab-active"}`}
        onClick={() => onClick(2)}
      >
        <CustomText
          size={"medium"}
          color={active === 2 ? "black" : "white"}
          weight={"700"}
        >
          Week
        </CustomText>
      </div>
    </div>
  );
};
function convertMillisecondsToSeconds(milliseconds: number) {
  const seconds = Math.floor(milliseconds / 1000);
  const remainingMilliseconds = (milliseconds % 1000).toFixed(1);

  return `${seconds}:${remainingMilliseconds}`;
}
const IsomorphicButton = ({
  rank,
  name,
  number,
  time,
}: {
  rank: number;
  name: string;
  number: number;
  time: number;
}) => {
  return (
    <div
      style={{
        paddingBottom: 10,
        marginTop: 10,
        marginRight: "5%",
        marginLeft: "5%",
        width: "90%",
      }}
      className="pointer"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: 50,
          borderRadius: "5px",
          backgroundColor: "#fff",
          boxShadow:
            "inset 6px 6px 10px 0 #D9D3CB, inset -6px -6px 10px 0 rgba(255, 255, 255, 0.5)",
          userSelect: "none",
          textAlign: "left",
        }}
      >
        <div style={{ marginRight: 20 }}>
          <div
            style={{
              width: "50px",
              height: "50px",
              marginLeft: -10,
              borderRadius: "50%",
              display: "inline-flex",

              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              backgroundColor: rank % 2 !== 0 ? "#FFCC4A" : "#B3CBDE",
              padding: "5px",
              boxShadow: "0px 0px 10px #eee",
            }}
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 0px 20px #aaa",
              }}
            >
              <CustomText weight="800" size={"large"} color={Colors.primary}>
                {rank}
              </CustomText>
            </div>
          </div>
        </div>

        <CustomText
          size="medium"
          weight="700"
          color={Colors.primary}
          style={{ flex: 1, textAlign: "left" }}
        >
          {" "}
          {name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()}
        </CustomText>

        <CustomText
          size="xsmall"
          weight="500"
          color={Colors.primary}
          style={{ width: "26%" }}
        >
          {formatDuration(time)}
          {/* {(Math.round(time / 1000) / 60).toString().replace(".", ":")} */}
        </CustomText>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "10%",
            alignItems: "flex-end",
            paddingRight: 20,
          }}
        >
          <CustomText size="medium" weight="800" color={Colors.primary}>
            {number}
          </CustomText>
          <CustomText size="xxsmall" weight="500" color={Colors.primary}>
            PTS
          </CustomText>
        </div>
      </div>
    </div>
  );
};
const UserRank = ({
  rank,
  name,
  number,
  time,
  circle,
}: {
  rank?: number;
  name?: string;
  number?: number;
  time?: number;
  circle?: boolean;
}) => {
  function formatRank(rank: number | undefined) {
    if (rank && rank >= 1000000000) {
      return (rank && rank / 1000000000).toFixed(1) + "B";
    } else if (rank && rank >= 1000000) {
      return (rank && rank / 1000000).toFixed(1) + "M";
    } else if (rank && rank >= 1000) {
      return (rank && rank / 1000).toFixed(1) + "K";
    } else {
      return rank;
    }
  }

  return (
    <div
      style={{
        paddingBottom: 10,
        marginTop: 10,
        marginRight: "5%",
        marginLeft: "5%",
        width: "90%",
      }}
      className="pointer"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: 50,
          borderRadius: "5px",
          backgroundColor: Colors.brownPrimary,
          userSelect: "none",
          textAlign: "left",
        }}
      >
        <div style={{ marginRight: 20 }}>
          <div
            style={{
              minWidth: "50px",
              width: circle ? 50 : "fitContent",
              height: "50px",
              marginLeft: -10,
              borderRadius: 500,
              display: "inline-flex",

              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              backgroundColor: Colors.brownPrimary,
              padding: "5px",
              // boxShadow: "0px 0px 10px #eee",
            }}
          >
            <div
              style={{
                minWidth: "50px",
                width: circle ? 50 : "fitContent",
                height: "50px",
                borderRadius: 100,
                backgroundColor: "#fff",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 0px 20px #aaa",
                paddingInline: 20,
                boxSizing: "border-box",
              }}
            >
              <CustomText weight="800" size={"large"} color={Colors.primary}>
                {formatRank(rank)}
              </CustomText>
            </div>
          </div>
        </div>

        <CustomText
          size="medium"
          weight="700"
          color={Colors.white}
          style={{ flex: 1, textAlign: "left" }}
        >
          {" "}
          {name && name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()}
        </CustomText>

        <CustomText
          size="xsmall"
          weight="500"
          color={Colors.white}
          style={{ width: "26%" }}
        >
          {formatDuration(time ? time : 0)}

          {/* {(Math.round(time / 1000) / 60).toString().replace(".", ":")} */}
        </CustomText>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "10%",
            alignItems: "flex-end",
            paddingRight: 20,
          }}
        >
          <CustomText size="medium" weight="800" color={Colors.white}>
            {number}
          </CustomText>
          <CustomText size="xxsmall" weight="500" color={Colors.white}>
            PTS
          </CustomText>
        </div>
      </div>
    </div>
  );
};

function LeaderBoardSegment({
  amount,
  tabActive,
  setActive,
  name,
  myData,
  onReload,
  goHome,
  page,
  setPage,
  onShare,
  onLogoClick,
  onLoad,
}: MatchProps) {
  const [active, setActive2] = useState(tabActive || 1);
  const [data, setData] = useState(getLeaderBoard());
  const [userData] = useState(getUserData());
  const [_, forceUpdate] = useReducer((x) => x + 1, 0);
  const [currentPage, setCurrentPage] = useState(page);
  const [series, setSeries] = useState<RankedUser[]>([]);
  const [weekly, setWeekly] = useState<RankedUser[]>([]);
  const [loading, setLoading] = useState(false);
  const [pointData, setPointData] = useState<{
    weeklytotal: number;
    total: number;
  }>(getTotalPoint());
  const handleSetActive = (tab: number) => {
    cleanLeaderBoard();
    setActive2(tab);
    setActive(tab);
  };
  useEffect(() => {
    loadTotalPoint();
    if (active === 1) setData(series);
    else setData(weekly);
  }, [active]);

  useEffect(() => {
    setPage(currentPage);
    cleanLeaderBoard();
    loadDataWithTImer();
  }, [currentPage]);

  const loadDataWithTImer = () => {
    setTimeout(() => {
      if (getLeaderBoard() === null) {
        onReload();
        loadDataWithTImer();
      } else {
        setData(getLeaderBoard());
        forceUpdate();
      }
    }, 1000);
  };
  const loadTotalPoint = () => {
    setTimeout(() => {
      if (getTotalPoint() === null) {
        onReload();
        loadDataWithTImer();
      } else {
        setPointData(getTotalPoint());
        forceUpdate();
      }
    }, 1000);
  };
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      let data1 = await onLoad(1);
      setSeries(data1.ranked_users);
      let data2 = await onLoad(2);
      setWeekly(data2.ranked_users);
      setLoading(false);
    };
    loadData();
  }, []);

  if (getUserData() !== null && data) {
    let userrank: MyRanking | undefined = getRank();
    let points = pointData
      ? active === 1
        ? pointData.total
        : pointData.weeklytotal
      : 0;
    let rankPercent = percentageCalculator({
      currentRank: userrank
        ? active === 1
          ? userrank.accumulated_rank
          : userrank.weekly_rank
        : 0,
      total:
        active === 1 ? getCount().user_count : getCount().weekly_user_count,
    });

    let rank = userrank
      ? active === 1
        ? userrank.accumulated_rank
        : userrank.weekly_rank
      : 0;

    let cutoff = active === 1 ? 40 : 20;

    const itemsPerPage = cutoff;

    let user_id = getUserData().mamba_id;

    let userInfo = data?.find((user) => user.user_mid === user_id);

    let userRank = userInfo?.rank;

    const handleShare = () => {
      if (onShare) {
        onShare();
      }
    };

    return (
      <div className="relative flexColumn otherLeaderBoardContainer">
        <MatchTitle />
        <Header share={true} onShare={handleShare} />
        <HeaderDropdown onLogoClick={onLogoClick}>
          <CustomText
            size="large"
            weight="400"
            color={Colors.blueLight}
            spacing={5}
            marginTop={40}
            marginBottom={5}
          >
            LEADERBOARD
          </CustomText>
          <CustomText
            size="medium"
            weight="400"
            color={Colors.brownPrimary}
            marginBottom={10}
          >
            {userData.first_name} {userData.last_name}
          </CustomText>
          <div className="containerStatisticsHeader">
            <TabContainer active={active} onClick={handleSetActive} />
            <div
              className="containerPicksHeaderDropdownPointsContainer"
              style={{
                width: "80%",
                justifyContent: "space-between",
                marginBottom: 20,
                marginTop: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                {/* <img
                src={Point}
                alt=""
                width={23}
                height={23}
                style={{ marginTop: 5, marginBottom: 5 }}
              /> */}

                <CustomText
                  size="xlarge"
                  weight="800"
                  color={Colors.backgroundPrimary}
                  marginBottom={5}
                >
                  {points ? points : 0}
                </CustomText>
                <CustomText size="small" weight="500" color={Colors.blueGray}>
                  PTS
                </CustomText>
              </div>
              <div className="containerPicksHeaderDropdownPointsSeparator"></div>
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <CustomText
                    size="small"
                    weight="500"
                    color={Colors.blueGray}
                    marginBottom={5}
                  >
                    Percentile
                  </CustomText>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {/* <img
                    src={Rank}
                    alt=""
                    width={23}
                    height={23}
                    style={{ marginRight: 20 }}
                  /> */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "start",
                      }}
                    >
                      <CustomText
                        size="xlarge"
                        weight="800"
                        color={Colors.backgroundPrimary}
                      >
                        {rankPercent ? rankPercent : 0}
                      </CustomText>
                      <CustomText
                        size="medium"
                        weight="500"
                        color={Colors.backgroundPrimary}
                        marginLeft={5}
                        marginTop={2}
                      >
                        %
                      </CustomText>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <CustomText
                    size="small"
                    weight="500"
                    color={Colors.blueGray}
                    marginBottom={5}
                    marginTop={10}
                  >
                    Rank
                  </CustomText>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {/* <img
                    src={Step}
                    alt=""
                    width={23}
                    height={23}
                    style={{ marginRight: 20 }}
                  /> */}
                    <CustomText
                      size="xlarge"
                      weight="800"
                      color={Colors.backgroundPrimary}
                    >
                      {rank ? formatNumber(rank) : 0}
                    </CustomText>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </HeaderDropdown>
        <center style={{ padding: 10, marginTop: 10, marginBottom: 10 }}>
          <div className="otherLeaderBoardTitle">
            <CustomText
              spacing={3}
              size="xxlarge"
              weight="300"
              color={"#4C728E"}
            >
              {active === 1 ? "SERIES LEADERBOARD" : "WEEKLY LEADERBOARD"}
            </CustomText>
          </div>
        </center>
        <div
          style={{
            boxShadow: "0px 0px 5px #ccc",
            borderRadius: 10,
            padding: 10,
            marginLeft: "5%",
            marginRight: "5%",
            backgroundColor: Colors.white,
            maxWidth: 553,
            width: "100%",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "90%",
              marginLeft: "5%",
              marginRight: "5%",
              display: "flex",
              borderRadius: 10,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              textAlign: "left",
            }}
          >
            <CustomText
              size="xsmall"
              color={Colors.primary}
              style={{ width: "26%" }}
            ></CustomText>
            <CustomText
              size="xsmall"
              color={Colors.primary}
              style={{ flex: 1 }}
            ></CustomText>
            <CustomText
              size="xsmall"
              color={Colors.primary}
              style={{ width: "26%" }}
            >
              Time
            </CustomText>
            <CustomText
              size="xsmall"
              color={Colors.primary}
              style={{ width: "10%", textAlign: "right", marginRight: 20 }}
            >
              Points
            </CustomText>
          </div>
          {loading && (
            <Oval
              height={30}
              width={30}
              color="orangered"
              wrapperStyle={{ justifyContent: "center" }}
              wrapperClass=""
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="gray"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          )}
          {!loading &&
            data &&
            data
              ?.slice(0, cutoff)
              ?.slice(
                currentPage * itemsPerPage,
                (currentPage + 1) * itemsPerPage
              )
              .map((item: RankedUser, index: number) => {
                return (
                  <>
                    {item?.user_mid === user_id ? (
                      <UserRank
                        circle
                        key={index}
                        rank={index + 1}
                        name={item.username}
                        number={item.points}
                        time={item.response_time_total}
                      />
                    ) : (
                      <IsomorphicButton
                        key={index}
                        rank={index + 1}
                        name={item.username}
                        number={item.points}
                        time={item.response_time_total}
                      />
                    )}
                  </>
                );
              })}
          <ReactPaginate
            pageCount={10}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            containerClassName={"containerPagination  hidden"}
            activeClassName={"containerPaginationActive"}
            pageClassName={"containerPaginationPage-item"}
            previousClassName={"page-item hidden"}
            nextClassName={"page-item hidden"}
          />

          {userRank && userRank > cutoff && (
            <UserRank
              rank={userInfo?.rank}
              name={userInfo?.username}
              number={userInfo?.points}
              time={userInfo?.response_time_total}
            />
          )}
        </div>
      </div>
    );
  } else {
    goHome();
    return null;
  }
}

export function formatDuration(milliseconds: number) {
  const seconds = Math.floor((milliseconds / 1000) % 60);
  const minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
  const hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
  const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

  if (hours === 0) {
    return `${formattedMinutes}:${formattedSeconds}`;
  } else {
    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }
}

export default LeaderBoardSegment;
